import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wizard-hel',
  templateUrl: './wizard-help.component.html',
  styleUrls: ['./wizard-help.component.scss']
})
export class WizardHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
